<script>
  import { format } from 'svelte-i18n';
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Tooltip } from '@sveltestrap/sveltestrap';

  import { Color } from '@client/components/color';
  import { Icon } from '@client/components/icon';

  import { colorBackground, colorPrimary, colorSecondary, colorTertiary, colorText } from '@client/stores/brand';

  import { generateUUID } from '@common/utils/strings';

  export let size = 'sm';
  export let value;
  export let onChange = () => {};

  const id = `color-dropdown-${generateUUID()}`;

  let invalidColor = false;
  let showDropdownMenu = false;

  $: onChange(value);

  $: brandColors = [
    $colorPrimary && {
      label: 'label.BRAND_PRIMARY_COLOR',
      value: $colorPrimary
    },
    $colorSecondary && {
      label: 'label.BRAND_SECONDARY_COLOR',
      value: $colorSecondary
    },
    $colorTertiary && {
      label: 'label.BRAND_TERTIARY_COLOR',
      value: $colorTertiary
    },
    $colorBackground && {
      label: 'label.BRAND_BACKGROUND_COLOR',
      value: $colorBackground
    },
    $colorText && {
      label: 'label.BRAND_TEXT_COLOR',
      value: $colorText
    }
  ].filter(Boolean);

  $: hasBrandColors = brandColors.length > 0;
</script>

<Color
  {...$$restProps}
  bsSize={size}
  bind:value
  bind:invalidColor
  style={hasBrandColors && !invalidColor
    ? 'border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important;'
    : ''}
>
  {#if hasBrandColors && !invalidColor}
    <Dropdown isOpen={showDropdownMenu} toggle={() => (showDropdownMenu = !showDropdownMenu)}>
      <DropdownToggle {id} class="editor-color-toggle" size="sm">
        <Icon name="droplet" />
      </DropdownToggle>
      <Tooltip target={id} placement="bottom">{$format('label.BRAND_COLORS')}</Tooltip>
      <DropdownMenu end>
        {#each brandColors as color}
          <DropdownItem class="py-2 px-3" active={color.value === value} on:click={() => (value = color.value)}>
            <small class="editor-color-item">
              <div class="color-swatch" style="background-color: {color.value};" />
              <div class="name">{$format(color.label)}</div>
            </small>
          </DropdownItem>
        {/each}
      </DropdownMenu>
    </Dropdown>
  {/if}
</Color>

<style lang="scss">
  :global {
    .editor-color-toggle {
      align-items: center;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      border-color: var(--border-color);
      display: flex;
      height: 30px;
      justify-content: center;
      width: 35px;

      &:hover,
      &:active,
      &:focus {
        border-color: var(--border-color) !important;
      }
    }

    .editor-color-item {
      align-items: center;
      display: flex;

      .color-swatch {
        border: 1px solid var(--border-color);
        border-radius: 100%;
        display: inline-block;
        margin-right: 0.5rem;
        min-height: 1.5rem;
        min-width: 1.5rem;
      }
    }
  }
</style>
